"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponseSchema = exports.QuerySchema = exports.method = exports.path = void 0;
exports.parseQuery = parseQuery;
exports.parseResponse = parseResponse;
const zod_1 = require("zod");
const common_1 = require("../../common");
const lingo2_models_1 = require("lingo2-models");
// Здесь указываем path относительно основного роута
// например `${config.http.webUrl}` `${config.http.panelUrl}` `${config.http.backUrl}`
/** Относительно `${config.http.*}` */
exports.path = 'user-profile/info';
exports.method = common_1.HttpMethod.GET;
// #region Request
// Тело запроса. Optional
// export const BodySchema = z.object({});
// export type Body = z.infer<typeof BodySchema>;
// export function parseBody(values: Body) {
//   return BodySchema.parse(values);
// }
// Параметры запроса. Optional
// export const ParamsSchema = z.object({});
// export type Params = z.infer<typeof ParamsSchema>;
// export function parseParams(values: Params) {
//   return ParamsSchema.parse(values);
// }
// Query параметры запроса. Optional
exports.QuerySchema = zod_1.z.object({
  id: zod_1.z.string().uuid().optional(),
  slug: zod_1.z.string().optional()
});
function parseQuery(values) {
  return exports.QuerySchema.parse(values);
}
// #endregion
// #region Response
exports.ResponseSchema = zod_1.z.object({
  data: zod_1.z.object({
    _id: zod_1.z.string().uuid(),
    slug: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    purl: zod_1.z.string().nullable(),
    coverId: zod_1.z.string().url().nullable(),
    avatarId: zod_1.z.string().url().nullable(),
    countryId: zod_1.z.string(),
    country: zod_1.z.object({
      flagUrl: zod_1.z.string().url(),
      name: zod_1.z.string(),
      titleNative: zod_1.z.string()
    }),
    lastActiveAt: zod_1.z.string().datetime(),
    isTeacher: zod_1.z.boolean(),
    isVerifiedTeacher: zod_1.z.boolean(),
    spokenLanguages: zod_1.z.array(zod_1.z.object({
      levelId: zod_1.z.number(),
      languageId: zod_1.z.number()
    })),
    teachingSubjects: zod_1.z.array(zod_1.z.object({
      subjectId: zod_1.z.number(),
      description: zod_1.z.string(),
      videoId: zod_1.z.string(),
      videoUrl: zod_1.z.string().url(),
      videoMode: zod_1.z.nativeEnum(lingo2_models_1.ProfileMediaModeEnum)
    })),
    about: zod_1.z.string(),
    workExperiences: zod_1.z.array(zod_1.z.object({
      organization: zod_1.z.string(),
      position: zod_1.z.string(),
      beginYear: zod_1.z.number(),
      endYear: zod_1.z.number()
    })),
    educationSchools: zod_1.z.array(zod_1.z.object({
      schoolName: zod_1.z.string(),
      departmentName: zod_1.z.string(),
      beginYear: zod_1.z.number(),
      endYear: zod_1.z.number()
    })),
    educationDocs: zod_1.z.array(zod_1.z.string()),
    hasCollections: zod_1.z.boolean(),
    hasUserServices: zod_1.z.boolean(),
    hasLessons: zod_1.z.boolean(),
    hasSchools: zod_1.z.boolean(),
    hasPublications: zod_1.z.boolean(),
    hasReviews: zod_1.z.boolean(),
    numberOfSubscribers: zod_1.z.number().default(0),
    numberOfSubscriptions: zod_1.z.number().default(0),
    numberOfLessons: zod_1.z.number().default(0),
    numberOfMeetings: zod_1.z.number().default(0),
    numberOfStudents: zod_1.z.number().default(0),
    numberOfReviews: zod_1.z.number().default(0),
    rating: zod_1.z.number().default(0),
    visitInfo: zod_1.z.object({
      isMe: zod_1.z.boolean(),
      isSubscribed: zod_1.z.boolean(),
      isBookmarked: zod_1.z.boolean()
    })
  }).nullable()
});
function parseResponse(values) {
  return exports.ResponseSchema.parse(values);
}
// #endregion
